import { createFileRoute } from "@tanstack/react-router";
// helpers
import { useAccessPermission } from "@/helpers/acessPermission";
import { Download } from "lucide-react";
//reactQuery
import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
// component
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { ActionPlan } from "@/components/chart/action-plan";
import { Employees } from "@/components/chart/employee";
import { Debt } from "@/components/chart/debt";
import NotPermission from "@/components/NotPermission";
import { Finance } from "@/components/chart/finance";
import { Obligation } from "@/components/chart/obligation";
import { TaxObligations } from "@/components/chart/tax-obligations";
import { Label } from "@/components/ui/label";
import { YearSelector } from "@/components/YearSelector";
import { useState } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
//type financial,financialPlan,tax,tax,employee

import { getDashboard } from "@/services/overview";
import type { DashboardData } from "@/interfaces/dashboard";
import { Button } from "@/components/ui/button";
import { clearLocalStorage } from "@/helpers/accessLocalStorage";
import { ErrorResponse } from "@/types/ErrorResponse";
export const Route = createFileRoute("/_layout-private/report/overview/")({
  component: RouteComponent,
});

function RouteComponent() {
  // const [dashboardData, setDashboardData] =
  // 	React.useState<DashboardData | null>(null);
  const { dashboards } = useAccessPermission();
  const [selectedStartYear, setSelectedStartYear] = useState<number>(1111);
  const [selectedEndYear, setSelectedEndYear] = useState<number>(1111);
  const companyId = localStorage.getItem("companyId");
  // Fetch dashboard data when the component mounts
  // useQuery
  const { data: dashboardData, error } = useQuery<
    DashboardData,
    AxiosError<ErrorResponse>
  >({
    queryKey: ["dashboardData", selectedEndYear, selectedStartYear, companyId],
    queryFn: async () => {
      if (companyId) {
        const data = await getDashboard(
          companyId,
          selectedEndYear,
          selectedStartYear
        );
        return data;
      }
      throw new Error("Company ID not found");
    },
  });

  if (error) {
    if (error?.response?.data?.message === "LOGGED_OUT") {
      console.log("clearing storage due to logged out");
      clearLocalStorage();
      window.location.reload();
    }
  }

  return dashboards.isRead ? (
    <div>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>ລາຍງານ KPI</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mt-8">
        <CardHeader>
          <div className="flex justify-between">
            <div>
              <CardTitle>ລາຍງານລວມທັງໝົດ</CardTitle>
              <CardDescription>
                ຕາຕະລາງແບບລັດວິສາຫະກິດທັງໝົດທີ່ຖືກປະເມີນເປັນ KPI
              </CardDescription>{" "}
            </div>
            <div className="flex justify-end w-6/12 gap-x-2">
              <div>
                <Label htmlFor="">ເລືອກປີເລີມຕົ້ນ</Label>
                <YearSelector
                  value={selectedStartYear}
                  onYearChange={setSelectedStartYear}
                />
              </div>
              <div>
                <Label htmlFor="">ເລືອກປີສິ້ນສຸດ</Label>
                <YearSelector
                  value={selectedEndYear}
                  onYearChange={setSelectedEndYear}
                />
              </div>
              <div className="flex items-end">
                {dashboards.isDownload && (
                  <Button
                    className="flex text-green-800 bg-gray-100 gap-x-2"
                    variant="secondary"
                  >
                    <Download size={16} />
                    ດາວໂຫລດ PDF
                  </Button>
                )}
              </div>
            </div>
          </div>
        </CardHeader>
        <CardContent className="grid grid-cols-1 grid-rows-6 gap-4 min-h-[800px] [&>*]:max-h-[800px]">
          <div>
            <Debt data={dashboardData?.debt || []} />
          </div>
          <div>
            <Finance data={dashboardData?.financial || []} />
          </div>
          <div>
            <ActionPlan data={dashboardData?.financialPlan || []} />
          </div>
          <div>
            <Obligation data={dashboardData?.taxPlan || []} />
          </div>
          <div>
            <TaxObligations data={dashboardData?.tax || []} />
          </div>
          {/* <div>
						<Director data={dashboardData?.directors || []} />
					</div> */}
          <div>
            <Employees data={dashboardData?.employee || []} />
          </div>
        </CardContent>
      </Card>
    </div>
  ) : (
    <NotPermission />
  );
}
